import truncateMiddle from 'truncate-middle'

export const getShortPublicAddress = publicAddress => {
  return truncateMiddle(publicAddress, 6, 4, '...')
}
